<div class="car-container" dir="ltr">
  <div  class="card-container">
    <mat-card [ngClass]="{'card-item-m': isMobileView(), 'card-item': !isMobileView(), 'authorized-border': car.authorized_seller && localeService.israeliMarket, 'regular-border': !car.authorized_seller}"
              *ngFor="let car of cars" matRipple fxLayout="column" fxFlex>
      <!--        <mat-card [ngClass]="isMobileView() ? 'card-item-m' : 'card-item'" *ngFor="let car of cars" matRipple-->
      <!--                  fxLayout="column" fxFlex>-->
      <div style="height: 110px;width: calc(100% + 32px);margin: 0 -16px 0 -16px;" class="car-image-container">
        <img
          mat-card-image
          class="card-image"
          [appLazyLoad]="'assets/images/nocarph.jpg'"
          [targetImage]="car.url"
          alt="{{car.Manufacturer}} {{car.Model}}"
          (click)="openDialog(car)"
          height="110px"
        />

      </div>
      <fa-icon
        class="heart-icon"
        [icon]="car.isLiked ? fasFaHeart : farFaHeart"
        (click)="toggleLike(car)"
      ></fa-icon>

      <fa-icon *ngIf="car.myCarId !== null"
               class="cart-icon"
               [icon]="faShoppingCart"
      ></fa-icon>

      <!--          <svg-icon *ngIf="car.authorized_seller"-->
      <!--                    class="authorized"-->
      <!--                    [src]="'/assets/icons/certificate.svg'"-->
      <!--                    [svgStyle]="{width:'24px', height:'24px'}"-->
      <!--                    nbTooltip="ספק מאושר"-->
      <!--          ></svg-icon>-->

      <svg-icon *ngIf="car.Location === 'Israel' && localeService.israeliMarket"
                class="location"
                [src]="'/assets/icons/countries/'+ (car.Location ? 'israel' : 'israel') +'.svg'"
                [svgStyle]="{width:'16px'}"
                [nbTooltip]="'CAR_MARKET.LOCATED_IN_ISRAEL' | translate"
      ></svg-icon>

      <mat-card-content class="mat-card-content">

        <div class="m-1 pt-3">
          <div class="overview-style">
            <div [ngStyle]="{ 'background-color': '#5f7dff', 'border-bottom': '0px' }"
                 class="overview-cart parent-cart">
              <div class="inner-header flex-row">
                <!--                    <span class=" mt-4 heading-text white size14" [className]="car.Manufacturer == 'Mercedes-Benz' ? 'size12' : 'size14'">{{ car.Manufacturer }}</span>-->
                <span
                  class="mt-4 heading-text white"
                  [ngClass]="{ 'size12': car.Manufacturer === 'Mercedes-Benz', 'size14': car.Manufacturer !== 'Mercedes-Benz' }">
                      {{ car.Manufacturer }}
                    </span>
                <span class="mt-4 heading-id-text size14">{{car.id}}</span>
                <img *ngIf="car.IsHot"  class="mt-4 hot-icon" src="/assets/images/fire-30.png" alt="" width="25" height="30" />
              </div>
            </div>
          </div>
        </div>

        <div class="more-info">
          <div class="flex-row location-info">
            <span class="flex-cell location-text mr-4 bold pull-left" style="float:left;">{{ getFuelTypeHebrew(car.FuelType) }}</span>
            <span class="flex-cell location-text mr-4 bold pull-left truncate">{{ car.FinishLevel }}</span>
            <span class="flex-cell location-text mr-4 bold pull-left truncate" direction="ltr">{{ car.Model }}</span>

          </div>
          <div class="extra-info">
            <div class="flex-table">
              <div class="flex-row">
                <!--                  <div class="flex-cell bold">מחיר</div>-->
                <div *ngIf="importType === 'Commercial'" class="flex-cell bold big price">
                  {{currencyService.convertFromIls(car.C_Price) | currency: currencyService.code : currencyService.symbol : '1.0-0'}}<br/>
                  <span class="small" style="font-size:8pt">
                      {{ 'CAR_MARKET.PRICE_FROM_LAST_UPDATE' | translate }}
                      </span>
                </div>
                <div *ngIf="importType === 'Taxi'" class="flex-cell bold big price" style="height:55px">
                  <div style="flex-direction: row; align-items: center; display: flex;justify-content: space-around">
                    <div><img src="/assets/images/Taxi_logo.png" alt="" width="60" height="20" style="border:2px solid black; border-radius: 4px"/></div>
                    <span>{{currencyService.convertFromIls(car.C_PriceComTaxi) | currency: currencyService.code : currencyService.symbol : '1.0-0'}}</span>
                  </div>
                  <div style="margin-top: 0px;">
                    <span class="small" style="font-size:8pt">{{ 'CAR_MARKET.ESTIMATED_PRICE' | translate }} </span>
                    <span class="small" style="font-size:9pt; font-weight: bold">{{ 'CAR_MARKET.FOR_TAXI' | translate }}</span>
                    <span class="small" style="font-size:8pt">{{ 'CAR_MARKET.AFTER_CUSTOMS' | translate }} </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="extra-info-engine">
            <div class="flex-table">
              <div class="flex-row bold">
                <div class="flex-cell">{{ 'CAR_MARKET.YEAR_OF_MANUFACTURE' | translate }}</div>
                <div class="flex-cell">{{ 'CAR_MARKET.COLOR' | translate }}</div>
                <div class="flex-cell">{{ 'CARS.MILEAGE_HEADER' | translate }}</div>
              </div>
              <div class="flex-row">
                <div class="flex-cell">{{car.ManufactureDate | date:'yyyy'}}</div>
                <div class="flex-cell truncate">{{car.ExteriorColor}}</div>
                <div class="flex-cell">{{car.Mileage | number: '1.0-0'}}</div>
              </div>
            </div>
          </div>
          <div class="extra-info-engine">
            <div *ngIf="car.engine" class="flex-row bold engine-text">
              <div class="flex-cell">{{ 'CAR_MARKET.ENGINE' | translate }}</div>
              <div class="flex-cell">{{car.engine}}</div>
            </div>
          </div>
          <div  class="extra-info-engine authorized-seller">
            <div *ngIf="car.authorized_seller && localeService.israeliMarket" class="flex-row bold flex-with-icon">
              <div class="icon-width">
                <svg-icon
                  class="authorized"
                  [src]="'/assets/icons/certificate.svg'"
                  [svgStyle]="{width:'24px', height:'24px'}"
                  [nbTooltip]="'CARS.AUTHORIZED_SUPPLIER' | translate"
                ></svg-icon>
              </div>
              <div class="with-icon">{{ 'CARS.AUTHORIZED_SUPPLIER' | translate }}</div>

            </div>
          </div>
        </div>

        <!--            <div class="ad-id">-->
        <!--              <div class="flex-table">-->
        <!--                <div class="flex-row bold">-->
        <!--                  <div class="flex-cell">{{car.id}}</div>-->
        <!--                  <div class="flex-cell">מודעה מס</div>-->
        <!--                </div>-->


        <!--              </div>-->
        <!--            </div>-->

        <div class="card-actions">
          <button id="cars-grid-more-info-button"
                  mat-raised-button
                  color="primary"
                  class="interested-button full-width"
                  (click)="toggleMoreInfo(car)"
          >{{ 'CAR_MARKET.MORE_DETAILS' | translate }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
<!--    <div class="spinner-container" *ngIf="isLoading && hasMore">-->
<!--      <mat-progress-spinner mode="indeterminate" [diameter]="50"></mat-progress-spinner>-->
<!--    </div>-->
  </div>
<!--  <div class="card-container">-->

<!--    <mat-card [ngClass]="isMobileView() ? 'card-item-m' : 'card-item'" *ngFor="let car of cars" matRipple-->
<!--              fxLayout="column" fxFlex>-->
<!--      <div style="height: 110px;width: calc(100% + 32px);margin: 0 -16px 0 -16px;" class="car-image-container">-->
<!--        <img-->
<!--          mat-card-image-->
<!--          class="card-image"-->
<!--          [src]="car.url || 'assets/images/nocarph.jpg'"-->
<!--          alt="{{car.Manufacturer}} {{car.Model}}"-->
<!--          (click)="openDialog(car)"-->
<!--          height="110px"-->
<!--        />-->
<!--      </div>-->
<!--      <fa-icon-->
<!--        class="heart-icon"-->
<!--        [icon]="car.isLiked ? fasFaHeart : farFaHeart"-->
<!--        (click)="toggleLike(car)"-->
<!--      ></fa-icon>-->


<!--      <fa-icon *ngIf="car.myCarId !== null"-->
<!--               class="cart-icon"-->
<!--               [icon]="faShoppingCart"-->
<!--      ></fa-icon>-->
<!--      <div class="top-right">-->
<!--        <svg-icon *ngIf="car.Location === 'Israel'"-->
<!--                  [src]="'/assets/icons/countries/'+ (car.Location ? 'israel' : 'israel') +'.svg'"-->
<!--                  [svgStyle]="{width:'16px'}"-->
<!--                  class="location"-->
<!--                  nbTooltip="ממוקם בישראל"-->
<!--        ></svg-icon>-->

<!--        <fa-icon *ngIf="car.myCarId !== null"-->
<!--                 [icon]="faTimes"-->
<!--                 class="remove-icon"-->
<!--                 (click)="removeFromList(car)"-->
<!--        ></fa-icon>-->
<!--&lt;!&ndash;        <fa-icon *ngIf="car.myCarId !== null"&ndash;&gt;-->
<!--&lt;!&ndash;                 [icon]="faShoppingCart"&ndash;&gt;-->
<!--&lt;!&ndash;                 class="location"&ndash;&gt;-->
<!--&lt;!&ndash;        ></fa-icon>&ndash;&gt;-->
<!--      </div>-->
<!--      <mat-card-content class="mat-card-content">-->

<!--        <div class="m-1 pt-3">-->
<!--          <div class="overview-style">-->
<!--            <div [ngStyle]="{ 'background-color': '#5f7dff', 'border-bottom': '0px' }"-->
<!--                 class="overview-cart parent-cart">-->
<!--              <div class="inner-header flex-row">-->
<!--                <span class=" mt-4 heading-text white size14">{{ car.Manufacturer }}</span>-->
<!--                <span class="mt-4 heading-text size14"></span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="more-info">-->
<!--          <div class="location-info">-->
<!--            &lt;!&ndash;            <fa-icon [icon]="faMapMarkerAlt"></fa-icon>&ndash;&gt;-->
<!--            &lt;!&ndash;            <span class="location-text mr-4">{{ car.Port }}</span>&ndash;&gt;-->
<!--            <span class="location-text mr-4">{{ car.Model }}</span>-->

<!--          </div>-->
<!--          <div class="extra-info">-->
<!--            <div class="flex-table">-->
<!--              <div class="flex-row bold">-->
<!--                <div class="flex-cell">שנת ייצור</div>-->
<!--                <div class="flex-cell">צבע</div>-->
<!--                <div class="flex-cell">קילומטראג׳</div>-->
<!--              </div>-->
<!--              <div class="flex-row">-->
<!--                <div class="flex-cell">{{car.ManufactureDate | date:'yyyy'}}</div>-->
<!--                <div class="flex-cell">{{car.ExteriorColor}}</div>-->
<!--                <div class="flex-cell">{{car.Mileage}}</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="card-actions">-->
<!--          <button id="my-cars-grid-more-info-button"-->
<!--            mat-raised-button-->
<!--                  color="primary"-->
<!--                  class="interested-button full-width"-->
<!--                  (click)="toggleMoreInfo(car)"-->
<!--          >פרטים נוספים-->
<!--          </button>-->
<!--        </div>-->
<!--        &lt;!&ndash;        <div class="card-actions">&ndash;&gt;-->
<!--        &lt;!&ndash;          <button mat-raised-button&ndash;&gt;-->
<!--        &lt;!&ndash;                  color="primary"&ndash;&gt;-->
<!--        &lt;!&ndash;                  class="interested-button full-width"&ndash;&gt;-->
<!--        &lt;!&ndash;                  (click)="toggleInterest(car)"&ndash;&gt;-->
<!--        &lt;!&ndash;          >Interested</button>&ndash;&gt;-->
<!--        &lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </mat-card-content>-->
<!--      &lt;!&ndash;      <mat-card-actions align="end" class="card-actions">&ndash;&gt;-->
<!--      &lt;!&ndash;        <button mat-raised-button color="primary" class="interested-button full-width">Interested</button>&ndash;&gt;-->
<!--      &lt;!&ndash;        &lt;!&ndash;        <button mat-button>share 👍</button>&ndash;&gt;&ndash;&gt;-->
<!--      &lt;!&ndash;      </mat-card-actions>&ndash;&gt;-->
<!--    </mat-card>-->
<!--  </div>-->
</div>
<ng-container #host style="display: none"></ng-container>

